module.exports = __webpack_public_path__ + "static/media/slider1.c54e2751.jpg";